import { useState, useCallback, useEffect } from 'react';
import { storeCategoriesListener } from '~/firebase/listeners/store';

import { CollectionSnapShotFn } from '~/firebase/listeners/type';
import { Category, CategoryWithId } from '~/types/store/category';

export default function useStoreCategories(storeId: string) {
  const [categoriesMap, setCategoriesMap] = useState<Map<string, CategoryWithId>>(new Map());

  const handleCategoriesSnapshot = useCallback<CollectionSnapShotFn>(
    (snap) => {
      setCategoriesMap(
        snap.docs.reduce<Map<string, CategoryWithId>>((acc, doc) => {
          const category = doc.data() as Category;

          acc.set(doc.id, { id: doc.id, ...category });

          return acc;
        }, new Map()),
      );
    },
    [setCategoriesMap],
  );

  useEffect(() => {
    const unlisten = storeCategoriesListener(storeId, handleCategoriesSnapshot);

    return () => {
      unlisten();
    };
  }, [storeId]);

  return categoriesMap;
}
